import { Spin, Modal } from 'antd';
import { useState } from 'react';
import { useGetOrganizationsQuery } from '../../features/organization/organizationService';
import OrganizationCollapseView from '../../components/Organizations/OrganizationCollapseView';
import RoundedButton from '../../components/RoundedButton';
import OrganizationsNewTeamForm from './OrganizationsNewTeamForm';
import OrganizationsNewLocationForm from './OrganizationsNewLocationForm';
import AddNewOrganizationForm from './AddNewOrganizationForm';
import OrganizationPlaceOfService from '../../components/Organizations/OrganizationPlaceOfService';

const OrganizationsView = () => {
    const [open, setOpen] = useState<boolean>(false);
    const [selectedLocation, setSelectedLocation] = useState<string>('');
    const [openLocationModal, setOpenLocationModal] = useState<boolean>(false);
    const [selectedOrganization, setSelectedOrganization] =
        useState<string>('');
    const { data: organizations, isLoading } = useGetOrganizationsQuery({});
    const [openNewOrgModal, setOpenNewOrgModal] = useState<boolean>(false);
    const [selectedLocationId, setSelectedLocationId] = useState<string>('');
    const [openPlaceOfServiceModal, setOpenPlaceOfServiceModal] =
        useState<boolean>(false);
    const [teamName, setTeamName] = useState<string>('');
    const [orgId, setOrgId] = useState<string>('');
    const [teamId, setTeamId] = useState<string>('');

    return (
        <Spin spinning={isLoading}>
            <h1 className="d-flex align-items-center justify-content-between mb-5">
                <div>Organizations</div>
                <RoundedButton
                    className="mt-2 me-2"
                    style={{
                        backgroundColor: 'var(--hcrx-light-blue)',
                        color: 'white',
                    }}
                    onClick={() => {
                        setOpenNewOrgModal(true);
                    }}
                >
                    Add New Organization
                </RoundedButton>
            </h1>
            {organizations && organizations?.length > 0 && (
                <OrganizationCollapseView
                    data={organizations}
                    openModal={setOpen}
                    setSelectedLocation={setSelectedLocation}
                    setOpenLocationModal={setOpenLocationModal}
                    setSelectedOrganization={setSelectedOrganization}
                    setSelectedLocationId={setSelectedLocationId}
                    setOpenPlaceOfServiceModal={setOpenPlaceOfServiceModal}
                    setTeamName={setTeamName}
                    setOrgId={setOrgId}
                    setTeamId={setTeamId}
                />
            )}

            <Modal
                title={`Add New Organization`}
                centered
                className="new-team-modal my-3"
                open={openNewOrgModal}
                footer={null}
                onOk={() => setOpenNewOrgModal(false)}
                onCancel={() => setOpenNewOrgModal(false)}
                destroyOnClose
                width={1200}
            >
                <AddNewOrganizationForm setOrgModalOpen={setOpenNewOrgModal} />
            </Modal>

            
            <Modal
                title={`Add New Location to ${selectedOrganization}`}
                centered
                className="new-team-modal my-3"
                open={openLocationModal}
                footer={null}
                onOk={() => setOpenLocationModal(false)}
                onCancel={() => setOpenLocationModal(false)}
                destroyOnClose
                width={1000}
            >
                <OrganizationsNewLocationForm
                    orgId={orgId}
                    closeModal={setOpenLocationModal}
                />
            </Modal>

            <Modal
                title={`Add New Team to ${selectedLocation}`}
                centered
                className="new-team-modal my-3"
                open={open}
                footer={null}
                onOk={() => setOpen(false)}
                onCancel={() => setOpen(false)}
                destroyOnClose
                width={1200}
            >
                <OrganizationsNewTeamForm
                    selectedLocationId={selectedLocationId}
                    setTeamModalOpen={setOpen}
                />
            </Modal>
            
            <Modal
                title={`Add New Place of Service to ${teamName}`}
                centered
                className="new-team-modal my-3"
                open={openPlaceOfServiceModal}
                footer={null}
                onOk={() => setOpenPlaceOfServiceModal(false)}
                onCancel={() => setOpenPlaceOfServiceModal(false)}
                destroyOnClose
                width={1000}
            >
                <OrganizationPlaceOfService
                    teamId={teamId}
                    closeModal={setOpenPlaceOfServiceModal}
                />
            </Modal>
        </Spin>
    );
};

export default OrganizationsView;
